<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between px-2 px-md-0">
      <div>
        <div class="section-title">{{ $tc("user", 1) }}</div>
        <div class="section-subTitle my-2">{{ $t("cinemauser") }}</div>
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          v-if="$can('create', 'Users')"
          :disabled="isRoleID"
          variant="default"
          to="/user-management/add-user"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="row px-2 px-md-0">
      <div class="d-flex align-items-center my-2 col-12 col-md-6 col-lg-2">
        <!--<b-dropdown text="Name" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#" v-for="(loop , key) in 10" :key="key">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="No of Employees" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here asdasdasdasdas</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Stauts" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Last Updated" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>-->
        <!-- <div class="col-md-3"> -->
        <multiselect
          :options="extendedCinemaArray"
          v-model="selectedCinema"
          label="cine_name"
          track-by="cine_id"
          placeholder="Cinema"
          :allowEmpty="false"
          :showLabels="false"
          @input="getUserList()"
        ></multiselect>
        <!-- </div> -->
      </div>
      <div class="col-12 col-md-6 col-lg-2 my-2">
        <multiselect
          :options="extendedRoleArray"
          v-model="selectedRole"
          label="role_name"
          track-by="role_id"
          placeholder="Role"
          :allowEmpty="false"
          :showLabels="false"
          @input="getUserList()"
        ></multiselect>
      </div>
      <div class="col-12 col-md-6 col-lg-2 my-2">
        <b-form-input
          @input="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="col-12 col-md-6 col-lg-2 my-2">
        <multiselect
          :options="statusDropdown"
          v-model="isActive"
          label="name"
          track-by="value"
          placeholder="Select Status"
          :allowEmpty="false"
          :showLabels="false"
          @input="getUserList()"
        ></multiselect>
      </div>
      <div class="col-12 col-md-6 col-lg-2 my-2">
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div class="table-scroll">
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <div class="pr-3">{{ $tc("status", 2) }}</div>
            </th>
            <th>
              <div>
                <img
                  v-if="this.columnName != 'first_name'"
                  @click="onSortValue('first_name', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('first_name', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('first_name', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $tc("name", 2) }}
              </div>
            </th>
            <th>
              <div>{{ $tc("username") }}</div>
            </th>
            <th>
              <div>{{ $tc("cinema", 1) }}</div>
            </th>
            <th>
              <img
                v-if="this.columnName != 'role_name'"
                @click="onSortValue('role_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('role_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('role_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("role", 1) }}
            </th>
            <th>
              <div>{{ $tc("changePassword", 1) }}</div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(user, userKey) in users" :key="userKey">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="user.is_active === 'Y' ? 'active' : 'inactive'"
                ></StatusDot>

                <div
                  v-if="user.user_id !== userid && $can('update', 'Users')"
                  @click="onEditUser(user)"
                  class="btn-icon ml-4 cursor-pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
                <div
                  @click="onViewUser(user)"
                  class="btn-icon ml-2 cursor-pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              </div>
            </td>
            <td>
              {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
            </td>
            <td>{{ user.username }}</td>
            <td>{{ user.cinemaname }}</td>
            <td>{{ user.role_name }}</td>
            <td>
              <button
                v-if="$can('update', 'Users')"
                v-b-modal.editPassword
                @click="selectedUser(user.user_id)"
                class="btn-blue w-85"
              >
                Edit Password
              </button>
            </td>
          </tr>
        </tbody>

        <tbody v-if="users.length == 0">
          <tr>
            <td colspan="6">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      id="editPassword"
      title="Change Password"
      hide-footer
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      @hidden="closeEditPsssword"
    >
      <!-- <form> -->
      <div class="row mb-2 mx-0">
        <div class="col-12">
          <!-- Current / Existing Password -->
          <div
            class="col-lg-10 mx-auto align-self-center"
            v-if="showcurrentpassword"
          >
            <div class>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="password"
                    name="currentpass"
                    id="currentpass"
                    v-validate="'required'"
                    placeholder="."
                    v-on:keyup.enter="ProceedtoNewPassword"
                  />
                  <label>Current Logged In User's Password</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('currentpass')">{{
                    errors.first("currentpass")
                  }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click.prevent.stop="$bvModal.hide('editPassword')"
                  class="btn-white-lg w-50 mr-2"
                >
                  Cancel
                </button>
                <button
                  v-on:keyup.enter="ProceedtoNewPassword"
                  @click.prevent.stop="ProceedtoNewPassword"
                  class="btn-blue-lg w-50 ml-2"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>

          <!-- New Password -->
          <!-- <div class="col-lg-5 border-right" v-if="shownewpassword">
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <div
                      class="text-muted font-weight-light"
                      style="font-size:16px;"
                    >Password must contain:</div>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast6char"
                    >
                      <div class="text-muted">Atleaset 6 Character</div>
                    </b-form-checkbox>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1num"
                    >
                      <div class="text-muted">Atleaset 1 Number (0-9)</div>
                    </b-form-checkbox>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1uppercase"
                    >
                      <div class="text-muted">Atleaset 1 uppercase letter (A-Z)</div>
                    </b-form-checkbox>
                  </li>
                  <li>
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1lowercase"
                    >
                      <div class="text-muted">Atleaset 1 lowercase letter (a-z)</div>
                    </b-form-checkbox>
                  </li>
                </ul>
            </div>-->
          <div class="col-lg-10 pl-5 align-self-center" v-if="shownewpassword">
            <div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="epassword"
                    name="forgotpassword"
                    id="forgotpassword"
                    ref="forgotpassword"
                    v-validate="{
                      required: 'required',
                      regex:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                    }"
                    placeholder="."
                    autofocus
                  />
                  <label>Enter New Password</label>
                </div>
                <p class="error_msg">
                  <span
                    v-if="submitted && errors.has('forgotpassword')"
                    class="error_message"
                    >{{ errors.first("forgotpassword") }}</span
                  >
                </p>
              </div>
              <div class="mb-3">
                <div class="input-material">
                  <input
                    type="password"
                    v-model="cpassword"
                    name="forgotconfirm"
                    id="forgotconfirm"
                    v-validate="'required|confirmed:forgotpassword'"
                    placeholder="."
                    autofocus
                    v-on:keyup.enter="onFinalProceed"
                  />
                  <label>Confirm Password</label>
                </div>
                <p class="error_message">
                  <span
                    v-if="submitted && errors.has('forgotconfirm')"
                    class="error_message"
                    >{{ errors.first("forgotconfirm") }}</span
                  >
                </p>
              </div>
              <div class="d-flex">
                <button
                  @click.prevent.stop="$bvModal.hide('editPassword')"
                  class="btn-white-lg w-50 mr-2"
                >
                  Cancel
                </button>
                <button
                  v-on:keyup.enter="onFinalProceed"
                  @click.prevent.stop="onFinalProceed"
                  class="btn-blue-lg w-50 ml-2"
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </form> -->
    </b-modal>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { decryptString, encryptString } from "@/helper/collection";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      role_id: null,

      //for search
      debounce: null,
      searchValue: "",

      showcurrentpassword: true,
      shownewpassword: false,
      password: "",
      submitted: false,
      selectUser: "",
      epassword: "",
      cpassword: "",

      gridView: false,
      listView: true,
      statusDropdown: [
        { name: "Active", value: "Y" },
        { name: "Inactive", value: "N" },
        { name: "All", value: "" },
      ],
      users: [],
      Cinemas: [],
      cinemaname: "",
      rolename: "",
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },
      userid: "",
      isRoleID: true,
      //Sortinh data
      isSort: false,
      isAscending: true,
      orderby: null,
      columnName: "",
      isActive: {
        name: "Active",
        value: "Y",
      },
      selectedCinema: "Select Cinema",
      selectedRole: "Select Role",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
    filteredUsers() {
      if (!this.selectedCinema) {
        return this.users;
      }
      return this.users.filter((user) => {
        user.cinema_id === this.selectedCinema.cine_id;
      });
    },
    filteredUsersByRole() {
      if (!this.selectedRole) {
        return this.users;
      }
      return this.users.filter((user) => {
        user.role_id === this.selectedRole.role_id;
      });
    },
    // extendedCinemaArray() {
    //   let extend_array = [{ cine_name: "All", cine_id: null }, ...this.Cinemas];
    //   return extend_array;
    // },
    extendedCinemaArray() {
      let activeCinemas = this.Cinemas.filter(
        (cinema) => cinema.cine_is_active == true
      );
      return [{ cine_name: "All", cine_id: null }, ...activeCinemas];
    },
    // extendedRoleArray() {
    //   let extend_array = [{ role_name: "All", role_id: null }, ...this.Roles];
    //   return extend_array;
    // },
    extendedRoleArray() {
      let sortedRoles = [...this.Roles].sort((a, b) =>
        a.role_name.localeCompare(b.role_name)
      );
      return [{ role_name: "All", role_id: null }, ...sortedRoles];
    },
  },

  mounted() {
    this.getUserList();
    this.selectedCinema = "";
    this.selectedRole = "";
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    const { user_id, role_id } = this.secureStore.get("USINFO");
    this.userid = user_id;
    this.role_id = role_id;
    this.getviewingnumber();
    this.selectedCinema = "";
    this.selectedRole = "";
  },
  methods: {
    onCinemaSelectChange(event) {
      this.selectedCinema = this.Cinemas.find(
        (c) => c.cine_id === parseInt(event.target.value)
      );
      this.currentPage = 1;
      this.getUserList(this.selectedCinema);
    },
    onRoleSelectedChange(event) {
      this.selectedRole = this.Roles.find(
        (r) => r.role_id === parseInt(event.target.value)
      );
      this.currentPage = 1;
      this.getUserList(this.selectedRole);
    },
    closeEditPsssword() {
      this.showcurrentpassword = true;
      this.shownewpassword = false;
      this.epassword = "";
      this.cpassword = "";
      this.password = "";
    },
    selectedUser(value) {
      // console.log("value :", value);
      this.selectUser = value;
      // console.log("this.selectUser :", this.selectUser);
      // console.log("showcurrentpassword :", this.showcurrentpassword);
      // console.log("shownewpassword :", this.shownewpassword);
    },
    OnCloseModal() {
      this.$bvModal.hide("editPassword");
      this.shownewpassword = false;
      this.showcurrentpassword = true;
      this.password = "";
    },
    ProceedtoNewPassword() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            userid:
              this.role_id == 1 || this.role_id == 2
                ? this.userid
                : this.selectUser,
            userpassword: this.password,
          };
          UserService.VerifyCurrentPassword(payload).then((response) => {
            // console.log("response :", response);
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.showcurrentpassword = false;
              this.shownewpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },
    onFinalProceed() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          // let loader = this.$loading.show();
          let payload = {
            userid: this.selectUser,
            password: this.cpassword,
          };

          UserService.UpdateChangePassword(payload).then((response) => {
            // console.log("response :", response);
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.$bvModal.hide("editPassword");
              this.epassword = "";
              this.cpassword = "";
              this.password = "";
              this.showcurrentpassword = true;
              this.shownewpassword = false;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      this.currentPage = 1;
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getUserList();
      } else {
        this.currentPage = event;
        this.getUserList();
      }
    },

    //search
    onSearch(event) {
      // this.searchValue = "";
      this.currentPage = 1;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.currentPage = 1;
        this.searchValue = event;
        // this.getSearchUserList();
        this.getUserList();
      }, 1500);
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.currentPage = 1;
      this.getUserList();
    },

    getSearchUserList: function () {
      // let loader = this.$loading.show();

      let payload = {
        table: "users",
        searchValue: this.searchValue,
        is_active: this.isActive.value,
      };
      MasterService.GenericSearch(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.Records;
            this.rows = data.totalRows || data.Records.length;
            this.getCinemasList();
            this.getRolesList();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },

    getUserList: function (cine_id = null) {
      // let loader = this.$loading.show();
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        orderby: this.orderby,
        columnName: this.columnName,
        is_active: this.isActive.value,
        cine_id: this.selectedCinema.cine_id
          ? this.selectedCinema.cine_id
          : null,
        role_id: this.selectedRole.role_id ? this.selectedRole.role_id : null,
        searchValue:this.searchValue || ''
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.data;
            // console.log("this.users :", this.users);
            this.getCinemasList();
            this.getRolesList();
            // if (data.totalRows >= 10) {
            //   this.rows = data.totalRows;
            // } else {
            //   this.rows = data.totalRows;
            //   this.selectedvalue = data.totalRows;
            // }
            this.rows = data.totalRows;

            // loader.hide();
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
            // loader.hide();
          } else {
            this.$toasted.show(data.message);
            // loader.hide();
          }
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => {
      //     loader.hide();
      //   }, 100);
      // });
    },
    /* eslint-disable */
    onEditUser: function (user) {
      this.$router.push({
        path: "/user-management/edit-user",
        // query: { user_id: user.user_id },
        query: {
          key: encryptString(JSON.stringify({ user_id: user.user_id })),
        },
      });
    },
    onViewUser: function (user) {
      this.$router.push({
        path: "/user-management/view-user",
        // query: { user_id: user.user_id },
        query: {
          key: encryptString(JSON.stringify({ user_id: user.user_id })),
        },
      });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // console.log("cine_id :", cine_id);
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.users = this.users.map((user) => {
              this.Cinemas.map((cinema) => {
                if (String(user.cinema_id) === String(cinema.cine_id)) {
                  user["cinemaname"] = cinema.cine_name;
                }
              });
              return user;
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getRolesList: function () {
      this.Roles = [];
      let body = this.getRequestBody("GET", [], this.RolesMethod);
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              this.users = this.users.map((user) => {
                this.Roles.map((role) => {
                  if (String(user.role_id) === String(role.role_id)) {
                    user["rolename"] = role.role_name;
                  }
                });
                return user;
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
  watch: {
    selectedCinema: function (newVal, oldVal) {
      this.currentPage = 1;
      this.getUserList();
    },
    selectedRole: function (newVal, oldVal) {
      this.currentPage = 1;
      this.getUserList();
    },
    isActive: function (newVal, oldVal) {
      this.currentPage = 1;
      this.getUserList();
    },
    searchValue: function (newVal, oldVal) {
      this.currentPage = 1;
      // this.getSearchUserList();
      this.getUserList();
    },
  },
};
</script>
<style>
.hiddenimg {
  display: none;
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
}
.hiddenImageWrap:hover .hiddenimg {
  display: block;
}
.hiddenImageWrap {
  position: relative;
}

.table-scroll .list-view-table {
  table-layout: auto;
  white-space: nowrap;
}

.table-scroll .list-view-table th {
  padding: 10px 10px;
  font-weight: bold;
}
.movie-dropdown button {
  width: 106px;
}

.table-grid-90 {
  display: grid;
  grid-template-columns: 90% 10%;
}
.table-grid-94 {
  display: grid;
  grid-template-columns: 94% 6%;
}

.grid-inner {
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 3px;
  justify-content: space-evenly;
}

.red-sq {
  background: #f9ddcd;
  height: 15px;
  width: 15px;
  border: 1px solid red;
  border-radius: 50%;
}
.green-sq {
  background: #ddfdc7;
  height: 15px;
  width: 15px;
  border: 1px solid green;
  border-radius: 50%;
}
.grey-sq {
  background: #e4e4e4;
  height: 15px;
  width: 15px;
  border: 1px solid grey;
  border-radius: 50%;
}

.blue-sq {
  background: #4682bc;
  height: 15px;
  width: 15px;
  border: 1px solid blue;
  border-radius: 50%;
}

.font-blue {
  color: #4682bc;
  font-weight: bold;
}

.status-table th:last-child,
.status-table td:last-child {
  padding-right: 0px;
}

.status-table .status_table_stat {
  padding: 10px !important;
}

.blue-icon {
  cursor: pointer;
  padding: 0;
}
.movie-list-table td {
  padding: 4px 10px !important;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/users.vue